import React, { useEffect, useRef, useState } from "react";
import "./Accueil.scss";
import PropTypes from "prop-types";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import EvenementsContainer from "Components/Evenements/EvenementsContainer/EvenementsContainer";
import ActualitesContainer from "Components/Actualites/ActualitesContainer/ActualitesContainer";
import OffresContainer from "Components/Offres/OffresContainer/OffresContainer";
import { connect } from "react-redux";
import PresentationRP from "Components/PresentationRP/PresentationRP";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import ButtonsBarConnected from "Components/Header/ButtonsBarConnected/ButtonsBarConnected";
import SearchBar from "Components/SearchBar/SearchBar";
import RessourcesContainer from "Components/Ressources/RessourcesContainer/RessourcesContainer";
import { useFetchGet, fetchGet, useFetchGetConditional } from "Services/api";
import Loader from "Components/Loader/loader";
import { updateOffers } from "Redux/Actions/offersActions";
import { updateEvents } from "Redux/Actions/eventsActions";
import { updateNews } from "Redux/Actions/newsActions";
import { updateUniversities } from "Redux/Actions/universitiesActions";
import useWindowDimensions from "Services/useWindowsDimensions";
import EntrepriseCard from "Components/GestionAdmin/GestionMembres/EntreprisesPartenaires/EntrepriseCard/EntrepriseCard";
import { updateStates } from "Redux/Actions/statesActions";
import { formatDateDatabase } from "Services/functions";
import { isNotEmptyArray } from "Services/functions";
import { updateHome } from "Redux/Actions/homeActions";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";

/**
 * Permet d'afficher la page d'accueil
 * La version avant connexion et après connexion sont un peu différentes
 */
const Accueil = (props) => {
  const homeNewsUrl = new URL(
    `${process.env.REACT_APP_BASE_URL_API}/news/homepage?itemsPerPage=3`
  );
  const homeEventsUrl = new URL(
    `${process.env.REACT_APP_BASE_URL_API}/events/homepage?itemsPerPage=3`
  );
  const homeOffersUrl = new URL(
    `${process.env.REACT_APP_BASE_URL_API}/offers/homepage?itemsPerPage=4`
  );
  const [newsUrl, setNewsUrl] = useState(homeNewsUrl);
  const [eventsUrl, setEventsUrl] = useState(homeEventsUrl);
  const [offersUrl, setOffersUrl] = useState(homeOffersUrl);
  // récupération des données de l'api pour alimenter la page
  const dataStates = useFetchGetConditional(
    "/states",
    props.auth.token,
    props.states.statesData
  );
  const dataUniversities = useFetchGetConditional(
    "/universities",
    props.auth.token,
    props.universities.universitiesData
  );
  const dataTransmitters = useFetchGetConditional(
    "/transmitters",
    props.auth.token,
    props.secondaryTables.transmittersData
  );
  const dataCompanies = useFetchGet(
    "/companies?isPartner=1?itemsPerPage=3",
    props.auth.token
  );

  const clickOutsideRef = useRef(null);
  const [isVisibleSearch, setIsVisibleSearch] = useState(false);
  const [filtreMotsCles, setFiltreMotsCles] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        clickOutsideRef.current &&
        !clickOutsideRef.current.contains(event.target)
      ) {
        props.handleUpdateHome({
          currentSearch: "",
        });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clickOutsideRef]);
  /**
   * Réinitialisation des variables isSearched et des données filtrées
   * pour chaque state en cas de retour à la page d'accueil
   */
  useEffect(() => {
    props.handleUpdateOffers({ isSearched: false, offersFiltered: [] });
    props.handleUpdateEvents({ isSearched: false, eventsFiltered: [] });
    props.handleUpdateNews({ isSearched: false, newsFiltered: [] });
    return () => {
      props.handleUpdateOffers({ dataFromPagination: null });
      props.handleUpdateEvents({ dataFromPagination: null });
      props.handleUpdateNews({ dataFromPagination: null });
    };
  }, []);

  useEffect(() => {
    if (
      dataStates.loaded &&
      props.offers.dataFromPagination?.loaded &&
      props.events.dataFromPagination?.loaded &&
      props.news.dataFromPagination?.loaded &&
      props.home.currentSearch !== ""
    ) {
      setFiltreMotsCles(props.home.currentSearch);
      handleFilter(props.home.currentSearch);
    }
  }, [
    dataStates.loaded,
    props.offers.dataFromPagination?.loaded,
    props.events.dataFromPagination?.loaded,
    props.news.dataFromPagination?.loaded,
  ]);

  useEffect(() => {
    dataUniversities.loaded &&
      props.handleUpdateUniversities({
        universitiesData: dataUniversities.data,
      });
    dataStates.loaded &&
      props.handleUpdateStates({
        statesData: dataStates.data,
      });
    dataTransmitters.loaded &&
      props.handleUpdateSecondaryTables({
        transmittersData: dataTransmitters.data,
      });
  }, [dataUniversities.loaded, dataStates.loaded, dataTransmitters.loaded]);

  useEffect(async () => {
    if (props.auth.isConnected)
      props.handleUpdateStates({
        groupMemberStatesData: await fetchGet(
          "/group_member_statuses",
          props.auth.token
        ),
      });
  }, [props.auth.isConnected]);

  const handleFilter = (value) => {
    if (!dataStates.loaded) return;
    const stateId = dataStates.data.find(
      (status) => status.statusLabel === "Publié"
    ).id;

    let urlOffers = new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`);
    let urlEvents = new URL(`${process.env.REACT_APP_BASE_URL_API}/events`);
    let urlNews = new URL(`${process.env.REACT_APP_BASE_URL_API}/news`);

    urlOffers.searchParams.set("order[modifiedAt]", "desc");
    urlOffers.searchParams.set("state", stateId);
    urlOffers.searchParams.set("itemsPerPage", 12);

    urlEvents.searchParams.set("state", stateId);
    urlEvents.searchParams.set(
      "endingAt[after]",
      formatDateDatabase(new Date())
    );
    urlEvents.searchParams.set("order[startingAt]", "asc");
    urlEvents.searchParams.set("itemsPerPage", 12);

    urlNews.searchParams.set("state", stateId);
    urlNews.searchParams.set("order[modifiedAt]", "desc");
    urlNews.searchParams.set("itemsPerPage", 12);

    if (value != "") {
      setIsVisibleSearch(true);
      urlOffers.searchParams.set("keyword", value);
      urlEvents.searchParams.set("keyword", value);
      urlNews.searchParams.set("keyword", value);
    } else {
      setIsVisibleSearch(false);
    }

    setEventsUrl(urlEvents);
    setOffersUrl(urlOffers);
    setNewsUrl(urlNews);

    props.handleUpdateHome({
      currentSearch: value,
    });
  };
  // eslint-disable-next-line no-unused-vars
  const { height, width } = useWindowDimensions();
  return (
    <div>
      <Header>
        {props.auth.isConnected ? (
          <>
            <SearchBar
              searchText="Rechercher un emploi, découvrir les prochains événements..."
              setIsVisibleSearch={setIsVisibleSearch}
              filtreMotsCles={filtreMotsCles}
              setFiltreMotsCles={setFiltreMotsCles}
              handleFilter={(value) => {
                if (value === "") {
                  setNewsUrl(homeNewsUrl);
                  setEventsUrl(homeEventsUrl);
                  setOffersUrl(homeOffersUrl);
                } else {
                  handleFilter(
                    value
                      .toLowerCase()
                      .normalize("NFD")
                      .replace(/\p{Diacritic}/gu, "")
                  );
                }
              }}
            />
            <ButtonsBarConnected />
          </>
        ) : (
          <ButtonsBarDisconnected />
        )}
      </Header>

      {!props.auth.isConnected && <PresentationRP />}
      {/* {!props.auth.isConnected &&
        (props.offers.dataFromPagination?.loaded ? (
          <ChiffreContainer companyNumber={dataCompanies.data?.length} />
        ) : (
          <Loader />
        ))} */}

      {isNotEmptyArray(props.states.statesData) ? (
        isVisibleSearch &&
        props.offers.dataFromPagination?.data?.length === 0 &&
        props.events.dataFromPagination?.data?.length === 0 &&
        props.news.dataFromPagination?.data?.length === 0 ? (
          <div className="search_acceuil_empty">
            Aucun résultat ne correspond à votre recherche
          </div>
        ) : (
          <div className="accueil" ref={clickOutsideRef}>
            <div className="article_offres" id="article_offres">
              {(!isVisibleSearch ||
                props.offers.dataFromPagination?.data?.length > 0) && (
                <OffresContainer
                  title={
                    isVisibleSearch
                      ? "Resultats parmi les offres :"
                      : "LES DERNIÈRES OFFRES D'EMPLOI"
                  }
                  bouton={"Voir toutes les offres d'emploi"}
                  nbOffre={
                    isVisibleSearch ? 12 : width > 1302 && width < 1682 ? 3 : 4
                  }
                  queryUrl={offersUrl}
                />
              )}
            </div>
            <div className="article_evenements" id="article_evenements">
              {(!isVisibleSearch ||
                props.events.dataFromPagination?.data?.length > 0) && (
                <EvenementsContainer
                  title={isVisibleSearch && "Resultats parmi les événements :"}
                  pageEvents="accueil"
                  nbEvents={isVisibleSearch ? 12 : width >= 1744 ? 3 : 6}
                  queryUrl={eventsUrl}
                />
              )}
            </div>
            <div className="article_actualites" id="article_actualites">
              {(!isVisibleSearch ||
                props.news.dataFromPagination?.data?.length > 0) && (
                <ActualitesContainer
                  title={isVisibleSearch && "Resultats parmi les actus :"}
                  pageActus="accueil"
                  nbActus={isVisibleSearch ? 12 : width >= 1744 ? 3 : 6}
                  queryUrl={newsUrl}
                />
              )}
            </div>
            {!isVisibleSearch && props.auth.isConnected && (
              <div className="article_conseils">
                <RessourcesContainer
                  pageRessources="accueil"
                  title="RESSOURCES ET GUIDES"
                />
              </div>
            )}
            {!isVisibleSearch && props.auth.isConnected && (
              <div className="article_partenaires">
                <h2>NOS ENTREPRISES PARTENAIRES</h2>
                <div className="cards_container">
                  {dataCompanies?.loaded &&
                  dataCompanies?.data &&
                  dataCompanies.data["hydra:member"].length > 0 ? (
                    dataCompanies.data["hydra:member"].map(
                      (company, index) =>
                        index < 3 && (
                          <EntrepriseCard
                            key={index}
                            nomEntreprise={company.name}
                            type={
                              company.structure
                                ? company.structure.label
                                : company.type.label
                            }
                            imageLogo="entreprise2"
                            imageFond="entrepriseFond1"
                            taille={
                              company.totalStaff
                                ? company.totalStaff.label
                                : "Non renseigné"
                            }
                            offresDisponibles={true}
                            isPartner={company.isPartner}
                            companyId={company.id}
                          ></EntrepriseCard>
                        )
                    )
                  ) : (
                    <span>
                      Aucune entreprise n&apos;est partenaire de Réseau Pro pour
                      le moment
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        )
      ) : (
        <Loader />
      )}

      <div className="footer__acceuil">
        <Footer />
      </div>
    </div>
  );
};

Accueil.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  handleUpdateOffers: PropTypes.func,
  handleUpdateEvents: PropTypes.func,
  handleUpdateNews: PropTypes.func,
  handleUpdateRessources: PropTypes.func,
  handleUpdateUniversities: PropTypes.func,
  handleUpdateStates: PropTypes.func,
  handleUpdateHome: PropTypes.func,
  handleUpdateSecondaryTables: PropTypes.func,
  states: PropTypes.object,
  offers: PropTypes.object,
  news: PropTypes.object,
  events: PropTypes.object,
  home: PropTypes.object,
  universities: PropTypes.object,
  secondaryTables: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  offers: state.offers,
  news: state.news,
  events: state.events,
  states: state.states,
  home: state.home,
  universities: state.universities,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateOffers: (value) => {
    dispatch(updateOffers(value));
  },
  handleUpdateEvents: (value) => {
    dispatch(updateEvents(value));
  },
  handleUpdateNews: (value) => {
    dispatch(updateNews(value));
  },
  handleUpdateUniversities: (value) => {
    dispatch(updateUniversities(value));
  },
  handleUpdateStates: (value) => {
    dispatch(updateStates(value));
  },
  handleUpdateHome: (value) => {
    dispatch(updateHome(value));
  },
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Accueil);
